import { render } from "./LwTable.vue?vue&type=template&id=50af40e0&scoped=true"
import script from "./LwTable.vue?vue&type=script&lang=js"
export * from "./LwTable.vue?vue&type=script&lang=js"

import "./LwTable.vue?vue&type=style&index=0&id=50af40e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50af40e0"]])

export default __exports__